var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"cclass":"base-select__new mr-1","textClass":"font-normal","value":_vm.currentFilter,"options":_vm.filterItems,"isSort":"","disabledHover":"","reverseArrow":"","defaultText":"generals.sort"},on:{"input":_vm.sortFunc}})}
var staticRenderFns = []

export { render, staticRenderFns }